import utilActions from '@/utils/actions';

const resetPasswordAction = {
	id: 'resetPasswordAction',
	selectionType: 'single',
	label: 'puiaction.resetpassword',
	functionality: 'CHANGE_USER_PASSWORDS',
	checkAvailability: function () {
		return true;
	},
	runAction: function (action, model, registries) {
		var dataRegistry = registries[0];
		this.$puiEvents.$emit('pui-modalDialog-resetPasswordUser-show', dataRegistry.usr);
	}
};

const disableUserAction = {
	id: 'disableUserAction',
	selectionType: 'single',
	label: 'puiaction.disableuser',
	functionality: 'WRITE_PUI_USER',
	checkAvailability: function (rows) {
		for (let index = 0, length = rows.length; index < length; index++) {
			const element = rows[index];
			if (element && element.disabled === 1) {
				return false;
			}
		}
		return true;
	},
	runAction: function (action, model, registries) {
		var dataRegistry = registries[0];
		var usr = dataRegistry.usr;
		var urlController = model.url.disableUser + '?usr=' + usr;
		var params = {};
		this.$puiRequests.getRequest(
			urlController,
			params,
			() => {
				this.$puiEvents.$emit('onPui-action-running-ended-' + model.name);
				utilActions.notifySuccess.call(this, this.$puiI18n.t(action.label));
			},
			() => {
				this.$puiEvents.$emit('onPui-action-running-ended-' + model.name);
				utilActions.notifyError.call(this, this.$puiI18n.t(action.label));
			}
		);
	}
};

const disableMassiveUserAction = {
	id: 'disableMassiveUserAction',
	selectionType: 'multiple',
	label: 'puiaction.disablemassiveuser',
	functionality: 'WRITE_PUI_USER',
	checkAvailability: function (user) {
		return !(user.disabled === 1);
	},
	runAction: function (action, model, registries) {
		const self = this;

		const total = registries.length;
		let completed = 0;
		let success = true;

		if (total === 0) {
			self.$puiEvents.$emit('onPui-action-running-ended-' + self.modelName);
			return;
		}

		const finish = () => {
			if (completed === total) {
				self.$puiEvents.$emit('onPui-action-running-ended-' + self.modelName);

				if (success) {
					utilActions.notifySuccess.call(self, self.$puiI18n.t(action.label));
				} else {
					utilActions.notifyError.call(self, self.$puiI18n.t(action.label));
				}

				// (Opcional) refrescar la tabla si hace falta
				if (self.$puiModel && self.$puiModel.reloadModel) {
					self.$puiModel.reloadModel(model.name);
				}
			}
		};

		registries.forEach((registry) => {
			const usr = registry.usr;
			const urlController = model.url.disableUser + '?usr=' + encodeURIComponent(usr);

			self.$puiRequests.getRequest(
				urlController,
				{},
				() => {
					completed++;
					finish();
				},
				() => {
					success = false;
					completed++;
					finish();
				}
			);
		});
	}
};


const enableUserAction = {
	id: 'enableUserAction',
	selectionType: 'single',
	label: 'puiaction.enableuser',
	functionality: 'WRITE_PUI_USER',
	checkAvailability: function (rows) {
		for (let index = 0, length = rows.length; index < length; index++) {
			const element = rows[index];
			if (element && element.disabled === 0) {
				return false;
			}
		}
		return true;
	},
	runAction: function (action, model, registries) {
		var dataRegistry = registries[0];
		var usr = dataRegistry.usr;
		var urlController = model.url.enableUser + '?usr=' + usr;
		var params = {};
		this.$puiRequests.getRequest(
			urlController,
			params,
			() => {
				this.$puiEvents.$emit('onPui-action-running-ended-' + model.name);
				utilActions.notifySuccess.call(this, this.$puiI18n.t(action.label));
			},
			() => {
				this.$puiEvents.$emit('onPui-action-running-ended-' + model.name);
				utilActions.notifyError.call(this, this.$puiI18n.t(action.label));
			}
		);
	}
};

export default {
	actions: [resetPasswordAction, disableUserAction, disableMassiveUserAction, enableUserAction],
	actionsLdap: [disableUserAction, disableMassiveUserAction, enableUserAction]
};
